import AuthenticatedLayout from 'portal/src/layouts/AuthenticatedLayout';
import TableProvider from 'portal/src/providers/TableProvider';

import { LayoutPreferenceProvider } from './LayoutPreference/LayoutPreferenceProvider';

export default function Authenticated() {
  return (
    <TableProvider>
      <LayoutPreferenceProvider>
        <AuthenticatedLayout />
      </LayoutPreferenceProvider>
    </TableProvider>
  );
}
